import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2 mb-6 xl:hidden overflow-auto no-scrollbar" }
const _hoisted_2 = { class: "xl:flex appointments_gap" }
const _hoisted_3 = { class: "hidden xl:block xl:w-1/4 xl:px-6" }
const _hoisted_4 = { class: "w-full xl:w-3/4 xl:px-6" }
const _hoisted_5 = { class: "tab-content pb_25" }
const _hoisted_6 = {
  class: "tab-pane opacity-0 opacity-100 block active",
  id: "tab1",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarketHeader = _resolveComponent("MarketHeader")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AccountSidebar = _resolveComponent("AccountSidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LayoutSection = _resolveComponent("LayoutSection")!
  const _component_BackGround = _resolveComponent("BackGround")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MarketHeader, { selectedHeader: "defaultHeader" }),
    _createElementVNode("main", null, [
      _createVNode(_component_LayoutSection, {
        sectionClass: "next_appointments_sidebar",
        paddingClass: "py-8",
        maxWidthClass: 'w-full'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_AppButton, {
                key: tab.id,
                to: tab.route,
                variant: "secondary",
                class: _normalizeClass(["account-tab px-2.5 py-2 whitespace-nowrap leading-tight", { 'font-bold border-black': _ctx.isActive(tab.route) }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_AccountSidebar)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_view)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_BackGround)
  ], 64))
}